import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/messaging";

export const firebaseConfig = {
    apiKey: "AIzaSyBktfTPjI4mXeW9aHf_t1q5AiRJFhWLVYQ",
    authDomain: "priority-pet.firebaseapp.com",
    databaseURL: "https://priority-pet.firebaseio.com",
    projectId: "priority-pet",
    storageBucket: "priority-pet.appspot.com",
    messagingSenderId: "869082577685",
    appId: "1:869082577685:web:fe72bd4dec8cb25ae6c71c",
    measurementId: "G-Y43D2W1BQY"
};

let messaging = null;

export const firebaseInitialize = (config) => {
    if (!firebase.apps.length) {
        firebase.initializeApp(config);
    };

    messaging = firebase.messaging();
};

export const getFirebaseApp = (name, config) => {
    let foundApp = firebase.apps.find(app => app.name === name);
    return foundApp ? foundApp : firebase.initializeApp(config || firebase.app().options, 'auth-worker');
}

export const firestoreInitialize = () => {
    return firebase.firestore();
};

export const SERVER_KEY = 'AAAAyllbuxU:APA91bFkC0SFUUggxHukBl-ntgYC_6gQ97mj46CYGc0cOeiAMf8D-MVqinDM1lYmsGn2xBKc6ZOIhHd_KaQJNyZeihu2WVrbjvtykxAh4ycu3qo6PGp4hU7hKr3gdnGAcCkEDRU1hHZx';
export const VAPID_KEY = 'BIYK8Takt6wVnGYDZxLx1fe5_NwEQQTNR8jtnfusdN4oxlMC9zRramEGs-MBLFLVWeGB_MBqkarnagZudYdnfRU';

export const getTokenMessaging = async () => {
  let currentToken = '';

  try {
    currentToken = await messaging.getToken({
      vapidKey:
        VAPID_KEY,
    });
  } catch (error) {
    return { hasError: true, error: error };
  }

  return currentToken;
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    messaging.onMessage((payload) => {
      resolve(payload);
    });
  });
